import { defineMessages } from 'react-intl';

export default defineMessages({
    condoReplacementCostLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.We have estimated that the replacement cost of your condo is: ',
        defaultMessage: 'We have estimated that the replacement cost of your condo is: '
    },
    homeReplacementCostLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.We have estimated that the replacement cost of your home is: ',
        defaultMessage: 'We have estimated that the replacement cost of your home is: '
    },
    valuationIdLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Valuation ID: ',
        defaultMessage: 'Valuation ID: '
    },
    nameLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Name: ',
        defaultMessage: 'Name: '
    },
    addressLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Address: ',
        defaultMessage: 'Address: '
    },
    calculatedLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Calculated: ',
        defaultMessage: 'Calculated: '
    },
    veriskDisclaimer: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.veriskDisclaimer',
        defaultMessage: 'The estimated replacement costs above represents the approximated costs required to rebuild a similar structure generally described herein in the referenced geographic market. It includes pricing for labor, materials, applicable, applicable permits and fees, sales tax, and contractor\'s overhead and profit. It does not include costs for major excavations or land value. This estimate is intended to function as one of the several sources of information in estimating a replacement cost and is not guaranteed to represent actual replacement costs in the event of damage or loss. (Replacement cost includes all applicable permits, fees, overhead, profit and sales tax).'
    },
    editHomeDetails: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.EDIT HOME DETAILS',
        defaultMessage: 'EDIT HOME DETAILS'
    },
    primaryHeatingType: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.What type of fuel is used by your heating system?',
        defaultMessage: 'What type of fuel is used by your heating system?'
    },
    oilTankUnderground: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Is your oil tank buried underground',
        defaultMessage: 'Is your oil tank buried underground'
    },
    oilTankDecommissioned: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Has this tank been decommissioned?',
        defaultMessage: 'Has this tank been decommissioned?'
    },
    oilTankDecommissionedTooltipTitle: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.tooltip.What is meant by decommissioned?',
        defaultMessage: 'What is meant by decommissioned?'
    },
    oilTankDecommissionedTooltipContent: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.tooltip.oilTankDecommissionedTooltipContent',
        defaultMessage: 'Decommissioned means to take the tank out of service by cleaning it, then removing it or filling it in place with sand, rock or concrete.  Simply emptying a tank, by itself, is not enough to consider the tank decommissioned.'
    },
    roofUpgradeDate: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.What year was the roof installed or updated?',
        defaultMessage: 'What year was the roof installed or updated?'
    },
    covALimitUpdatedAlert: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Coverage A limit has been updated to Estimated Replacement Cost value.',
        defaultMessage: 'Coverage A limit has been updated to Estimated Replacement Cost value.'
    },
    replacementCostSelectedHeader: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Verify Functional Replacement Cost.',
        defaultMessage: 'Verify Functional Replacement Cost'
    },
    replacementCostSelectedDescription: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Functional Replacement Cost has been removed for Building Property Loss Settlement coverage.',
        defaultMessage: 'Functional Replacement Cost is not available for the GrandProtect coverage level.  Please deselect the “Use Functional Replacement Cost” checkbox in the Home Details.'
    },
    readMoreFaq: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Read more',
        defaultMessage: 'Read more'
    },
    replacementCostTooltipTitle: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.What is replacement cost?',
        defaultMessage: 'What is replacement cost?'
    },
    functionalReplacementCostTooltipTitle: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.What is functional replacement cost?',
        defaultMessage: 'What is functional replacement cost?'
    },
    condoReplacementCostTooltipContent: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.condoReplacementCostTooltipContent',
        defaultMessage: 'Replacement cost is the amount of money it would take to repair, replace or rebuild your condo with materials similar to the kind and quality used in constructing your condo.  The estimated replacement cost takes into consideration material and labor costs to rebuild your condo in your area.'
    },
    replacementCostTooltipContent: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.replacementCostTooltipContent',
        defaultMessage: 'Replacement cost is the amount of money it would take to repair, replace or rebuild your home with materials similar to the kind and quality used in constructing your home.  The estimated replacement cost takes into consideration material and labor costs to rebuild your home in your area.'
    },
    functionalReplacementCostTooltipContent: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.functionalReplacementCostTooltipContent',
        defaultMessage: 'Functional Replacement cost is the amount of money it would take to repair, replace or rebuild your home with materials which are functionally equivalent (serves the same function) to materials used in constructing your home. The estimated replacement cost takes into consideration material and labor costs to rebuild your home in your area.'
    },
    imageryUnavailable: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Imagery is not available for this location',
        defaultMessage: 'Imagery is not available for this location'
    },
    close: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Close',
        defaultMessage: 'Close'
    },
    loadingImagery: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Loading Aerial Imagery',
        defaultMessage: 'Loading Aerial Imagery'
    },
    roofAgeChangeEligibilityReplacement: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.roofAgeChangeEligibilityReplacement',
        defaultMessage: 'Please review the renewal transaction to determine if the roof is eligible for replacement cost coverage due to the roof age change made in this transaction. As this change is being made within the levy period, coverage may have been removed during the renewal transaction.'
    },
    roofAgeThirdpartyInfo: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.roofAgeThirdpartyInfo',
        defaultMessage: 'Roof age was updated from third-party data, please review it.'
    },
    dwellingTypeLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Is the dwelling a mobile home, trailer, modular or manufactured home?',
        defaultMessage: 'Is the dwelling a mobile home, trailer or manufactured home?'
    },
    cuurentMarketValueLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Current market value minus land or ACV',
        defaultMessage: 'Current market value minus land or ACV'
    },
    dwellingClassificationLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Dwelling Classification',
        defaultMessage: 'Dwelling Classification'
    },
    uderConstructionLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Is the dwelling under construction?',
        defaultMessage: 'Is the dwelling under construction?'
    },
    typeOfConstructionLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.What type of construction is it?',
        defaultMessage: 'What type of construction is it?'
    },
    includePPLossofUselabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Do you want to include coverage for Personal Property and Loss of Use',
        defaultMessage: 'Do you want to include coverage for Personal Property and Loss of Use?'
    },
    solarpanelLabel: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.Are there any solar panels at the premises?',
        defaultMessage: 'Are there any solar panels at the premises?'
    },
    underConstructionNotification: {
        id: `ml.common.component.MLHOReplacementCostSummaryComponent.Under Construction Notification`,
        defaultMessage: `Policy will be endorsed with Course of Construction endorsement`
    },
    homeSharingAirBnbSelectedNotification: {
        id: `ml.common.component.MLHOReplacementCostSummaryComponent.Home Sharing AirBnb Selected Notification`,
        defaultMessage: `Home Sharing is not covered unless the Home Sharing Endorsement is selected in Optional Coverages and included in the policy. `
    },
    currentMarketValueError: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.current market value error',
        defaultMessage: `Current market value minus land or ACV value should be in multiple's of 1000.`
    },
    hydrantwithin1000feetLabel: {
        id: `ml.common.component.MLHOReplacementCostSummaryComponent.Hydrant within 1,000 feet`,
        defaultMessage: `Hydrant within 1,000 feet`
    },
    fireDistrictLabel: {
        id: `ml.common.component.MLHOReplacementCostSummaryComponent.Fire Distrit`,
        defaultMessage: `Fire District`
    },
    refreshButton: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.refresh',
        defaultMessage: `Refresh`
    },
    cmvTooltip: {
        id: `ml.common.component.MLHOReplacementCostSummaryComponent.tooltip.CMVToolTip`,
        defaultMessage: `<p>Current Market Value — The price a buyer would be willing to pay for the dwelling, minus the value of the land. To the public, current market value generally includes non-insured elements of the property, such as land and foundation, which reflects surrounding real estate market conditions. The current market value for insurance coverage purposes, and consequently for any claim settlement, does not include the non-insured elements. The rating base should reflect only the current market value for insurance coverage purposes.</p><p>Actual Cash Value — The cost to repair or replace property with conventional materials of like kind and quality, less allowance for physical deterioration and depreciation, including obsolescence.</p>`
    },
    roofUpgradeDateForNP: {
        id: 'ml.common.component.MLHOReplacementCostSummaryComponent.What year was the roof installed or completely updated?',
        defaultMessage: 'What year was the roof installed or completely updated?'
    },
});
